module.exports = (__webpack_require__("vB+P"))(69);


//////////////////
// WEBPACK FOOTER
// delegated ../node_modules/babel-runtime/core-js/promise.js from dll-reference main
// module id = //Fk
// module chunks = 71